import React from 'react';


const EmployeeSummary = (props) => {
	
	return <tr onClick={props.onClick} className={(props.className || '') + ' EmployeeSummary ' + (props.Visible === 'Y' ? 'Active' : 'NotActive')}>
		<td className="name">{props.FirstName} {props.LastName}</td><td title={props.HourlyRate['class']}>${props.HourlyRate.Rate.moneyFormat()}</td>
	</tr>;
}
export default EmployeeSummary;